<script setup>
import useApprovalTable from "./hooks/useApprovalTable";
import { APPROVAL_TYPE, PROCESS_STATUS, TAG_TYPE } from "@/constants";
import { onMounted } from "vue";
import ApprovalDialog from "./approvalDialog.vue";
import ApprovalDetail from "./approvalDetail.vue";

const {
  searchRef,
  searchData,
  columns,
  tableLoading,
  tableData,
  menuList,
  activeIndex,
  pages,
  approvalRef,
  countObj,
  countToMenu,
  approvalDetailRef,
  getList,
  handleReset,
  handleExport,
  handleMenuSelect,
  handleSubmitApproval,
  handleDetail,
} = useApprovalTable();

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '审核管理' }">
    <template #header-btn></template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item label="审批类型：" prop="category">
          <el-select
            v-model="searchData.category"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="item in APPROVAL_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="审批状态：" prop="processStatus">
          <el-select
            v-model="searchData.processStatus"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="item in PROCESS_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleMenuSelect"
      >
        <el-menu-item
          v-for="item in menuList"
          :key="item.index"
          :index="item.index"
          >{{ item.label }}({{
            countObj[countToMenu[item.index]]
          }})</el-menu-item
        >
      </el-menu>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <el-table-column label="序号" type="index" width="55" />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="[, 'category'].includes(item.prop)">{{
                row[item.prop].desc
              }}</span>
              <el-tag
                v-else-if="item.prop == 'processStatus'"
                :type="TAG_TYPE[row[item.prop]?.value]"
                >{{ row[item.prop].desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="180" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              @click="handleSubmitApproval(row)"
              v-if="row.processStatus.value == 2 && activeIndex != 'processed'"
              >审核</el-button
            >
            <el-button type="primary" link @click="handleDetail(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
        class="mt10"
      />
    </template>
  </zh-table-page>
  <!-- 审核弹窗 -->
  <approval-dialog ref="approvalRef" @after-approval="getList" />

  <!-- 审核详情弹窗 -->
  <approval-detail ref="approvalDetailRef" />
</template>

<style scoped></style>
